(() => {
  document.addEventListener("DOMContentLoaded", function () {
    const headerfooter = localStorage.getItem("headerfooter");

    const oneHourAgo = Date.now() - 1000 * 60 * 60 * 24 * 7;
    if (headerfooter && headerfooter.timestamp > oneHourAgo) {
      injectHeaderFooter(headerfooter.html);
    } else {
      fetch("/headerfooter.html")
        .then((response) => response.text())
        .then((html) => {
          localStorage.setItem("headerfooter", { html, timestamp: Date.now() });
          injectHeaderFooter(html);
        })
        .catch((error) => console.error("Error loading the header and footer", error));
    }
  });

  const getAndInjectElement = (content, selector, destParent) => {
    const element = content.querySelector(selector);
    if (element && destParent) {
      destParent.parentNode.replaceChild(element, destParent);
    } else {
      console.warn(`Unable to replace the ${selector} : missing element.`);
    }
  };

  const injectHeaderFooter = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    getAndInjectElement(tempDiv, "header", document.querySelector("header#header"));
    getAndInjectElement(tempDiv, "footer", document.querySelector("footer#footer"));
    applyMenuEvents();
  };
})();
